import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import type { ICellRendererParams } from '@ag-grid-community/core';
import type { PlanId, PlanMetadata } from 'src/state/scope/codecs/PlanMetadata';
import { AsyncThunk } from '@reduxjs/toolkit';
import type { ThunkApi } from 'src/store.types';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import { setRightContainerPayload } from 'src/components/RightContainer/RightContainer.slice';
import { RightContainerPayloadType } from '../../RightContainer/RightContainer';
import { Button } from '@material-ui/core';

const mapDispatchToProps = {
  setRightContainerPayload,
};

export type CommentsCellRender = ICellRendererParams &
  typeof mapDispatchToProps & {
    data: PlanMetadata;
    loadPlanComments: AsyncThunk<void, PlanId, ThunkApi>;
  };

function CommentsCellRenderer(props: CommentsCellRender) {
  const { loadPlanComments, data: planData, setRightContainerPayload } = props;

  const expand = useCallback(() => {
    loadPlanComments(planData.id);
    setRightContainerPayload({ type: RightContainerPayloadType.Comments });
  }, [loadPlanComments, planData.id, setRightContainerPayload]);

  return (
    <Button variant="contained" onClick={expand} style={{ padding: '8px', minWidth: 'unset' }}>
      <ForumOutlinedIcon style={{ color: '#0009', opacity: '.9' }} />
    </Button>
  );
}

export default connect(undefined, mapDispatchToProps)(CommentsCellRenderer);
